import { gu2px } from '@ux/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { percentage } from '@ux/style-utils';

const colBase = 12;
const percentageWidth = (cols) => percentage((cols / colBase) * 100);

export default ({
  theme,
  xsCols,
  mdCols,
  lgCols,
}) => {
  const {
    spacing,
  } = theme;

  return {
    default: {
      root: {
        overflow: 'hidden',
        paddingTop: gu2px(2, spacing),
      },

      row: {
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-staer',
        WebkitFlexWrap: 'wrap',
        msFlexWrap: 'wrap',
        flexWrap: 'wrap',
        marginLeft: 0,
        marginRight: 0,
      },

      item: {
        paddingLeft: 0,
        paddingRight: 0,
        position: 'relative',
        width: percentage(100),
        minHeight: 1,
        WebkitBoxFlex: 1,
        WebkitFlexBasis: 0,
        msFlexPreferredSize: 0,
        flexBasis: 0,
        WebkitFlexGrow: 1,
        msFlexPositive: 1,
        flexGrow: 1,
        marginBottom: gu2px(2, spacing),
        flex: `0 0 ${percentageWidth(xsCols)}`,
        maxWidth: percentageWidth(xsCols),
      },
    },

    tablet: {
      row: {
        // only start flexing here as IE11 doesn't like it when they stack
        // by default
        display: 'flex',
        ...cssSides('margin', Side.X, -(gu2px(1, spacing))),
        flexDirection: 'row',
      },
      item: {
        flex: `0 0 ${percentageWidth(mdCols)}`,
        maxWidth: percentageWidth(mdCols),
        ...cssSides('padding', Side.X, gu2px(1, spacing)),
      },
    },

    desktop: {
      row: {
        display: 'flex',
        ...cssSides('margin', Side.X, -(gu2px(1, spacing))),
        flexDirection: 'row',
      },
      item: {
        flex: `0 0 ${percentageWidth(lgCols)}`,
        maxWidth: percentageWidth(lgCols),
        ...cssSides('padding', Side.X, gu2px(1, spacing)),
      },
    },
  };
};
